import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";
import toast from "react-hot-toast";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();

    // ✅ Auto-login
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/dashboard");
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const res = await API.post("/Auth/login", {
                username: email,
                password: password,
            });

            const token = res.data.token;

            // ✅ Save token
            localStorage.setItem("token", token);

            // ✅ SUCCESS toast
            toast.success("Login successful 🚀");

            // ✅ Redirect
            navigate("/dashboard");

        } catch {
            toast.error("Invalid credentials ❌");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-black to-[#0f172a] text-white">

            <form
                onSubmit={handleLogin}
                className="bg-white/10 backdrop-blur-2xl border border-white/10 p-8 rounded-2xl w-80 shadow-2xl"
            >
                <h2 className="text-2xl font-bold mb-6 text-center">
                    🔐 Admin Login
                </h2>

                <input
                    className="w-full p-3 mb-3 bg-gray-900 rounded-lg outline-none focus:ring-2 focus:ring-purple-500"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                />

                <input
                    type="password"
                    className="w-full p-3 mb-4 bg-gray-900 rounded-lg outline-none focus:ring-2 focus:ring-purple-500"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                />

                <button className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 p-3 rounded-lg font-semibold hover:scale-105 transition">
                    Login
                </button>
            </form>
        </div>
    );
}